/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';

const INITSTATE = {};

export default function tripPlanner(state = INITSTATE, action) {
    let st = state;

    switch (action.type) {
        case types.GET_TRIP_DESTINATION_SUGGESTIONS:
            st = { ...state };
            st.suggestions = action.payload.suggestions;
            st.inventory_suggestions = action.payload.inventory_suggestions;
            delete st.err;
            return st;

        case types.GET_TRIP_DESTINATION_SUGGESTIONS_ERROR:
            st = { ...state };
            st.err = action.err;
            return st;

        default:
            return st;
    }
}
